import {
  MULTI_WALLS_LIMIT,
  WALL_DIRECTION
} from '../../utilities/constants/Constants';
import actionTypes from '../actionTypes';
import {
  clearCanvas,
  loadCanvasFromProject,
  destroyElement,
  continueAddToCanvas,
  setScenePlacingOffsetAndSize,
  getElementImagePath,
  calculateRoomAndWallViewSize
} from '../fabricCanvasActions';
import {
  checkIfCanvasApp,
  getActiveWall,
  updateCanvasForChangeInSize
} from '../homeActions';
import { Project } from '../ProjectData/Project';
import {
  initiateProjectSave,
  saveOnlyIfDirtyAndCall
} from '../projectSaveAndLoader';
import { renderJSONForWalls } from '../threeDViewActions';
import { renderProject } from '../../utilities/ProjectCanvasRenderer/ProjectCanvasRenderer';
import { isImageBasedBackground } from '../fabricCanvasActionHelpers';
import { deleteProject } from '../../services/api';
import { isWallcoveringApp } from '../../utilities/HelperFunctions/SignageHelperFunctions';
import { getDefaultProjectName } from '../../utilities/HelperFunctions/HelperFunctions';
import { setProjectName } from '../finalCheckActions';

export const multiWallSupport = () => (dispatch, getState) =>
  isWallcoveringApp(getState().modal.envData.category);

export const extendWall = inDirection => async (dispatch, getState) => {
  const { multiWallProjects, project } = getState().finalCheck;
  project.isMultiWall = true;

  const newProject = new Project();
  newProject.direction = inDirection;
  newProject.projectGroupId = project.projectGroupId;
  newProject.targetViewingDistance = project.targetViewingDistance;
  newProject.placeMsrpCurrency = project.placeMsrpCurrency;
  newProject.isMultiWall = true;

  if (dispatch(canStretchScene())) {
    dispatch(setSharedSceneTo(project, true));
  }

  if (inDirection == WALL_DIRECTION.LEFT) {
    newProject.projectGroupPosition = 1;
  } else {
    newProject.projectGroupPosition = multiWallProjects.length + 1;
  }

  dispatch(setWebLinkProjectNameAndCheckShouldSave()).then(() => {
    dispatch(setActiveProjectTempororily(newProject));
    dispatch(setWebLinkProjectName());

    const activeWall = dispatch(getActiveWall());
    activeWall.width = project.width;
    activeWall.height = project.height;
    dispatch(initiateProjectSave());
  });
};

export const setWebLinkProjectNameAndCheckShouldSave = () => (
  dispatch,
  getState
) =>
  new Promise(resolve => {
    const { project } = getState().finalCheck;

    // In case of weblink this check will be true. In non web link it will be false as we are setting default name
    // while initiating the project.
    if (!project.name || project.name == '') {
      const defaultName = dispatch(
        getDefaultProjectName(getState().modal.envData.category)
      );
      dispatch(setProjectName(defaultName));
      dispatch(saveOnlyIfDirtyAndCall().then(resolve));
    } else {
      resolve();
    }
  });

export const setWebLinkProjectName = () => (dispatch, getState) => {
  const { project } = getState().finalCheck;
  if (!project.name || project.name == '') {
    const defaultName = dispatch(
      getDefaultProjectName(getState().modal.envData.category)
    );
    dispatch(setProjectName(defaultName));
  }
};

export const deleteWall = inDirection => (dispatch, getState) => {
  const {
    activeMultiWallProjectIndex,
    multiWallProjects,
    project
  } = getState().finalCheck;

  let deleteProjectIndex = activeMultiWallProjectIndex;
  if (inDirection == WALL_DIRECTION.LEFT) {
    deleteProjectIndex -= 1;
    dispatch({
      type: actionTypes.SET_ACTIVE_MULTIWALL_PROJECT_INDEX,
      payload: {
        activeMultiWallProjectIndex: activeMultiWallProjectIndex - 1
      }
    });
  } else {
    deleteProjectIndex += 1;
  }

  const deletingProject = multiWallProjects[deleteProjectIndex];
  deleteProject(deletingProject.projectGroupId, deletingProject.id);
  multiWallProjects.splice(deleteProjectIndex, 1);
  dispatch({
    type: actionTypes.SET_MULTIWALL_PROJECTS,
    payload: {
      multiWallProjects
    }
  });
  if (multiWallProjects.length == 1) {
    project.isMultiWall = false;
  }
  dispatch(updateCanvasForChangeInSize());
  // Canvas size should update hence using timer here.
  setTimeout(() => {
    if (dispatch(isSharedScene())) {
      dispatch(stretchScene());
    }
  }, 1);
};

export const rearrangeProjectGroupPosition = () => (dispatch, getState) => {
  const { multiWallProjects } = getState().finalCheck;
  multiWallProjects.forEach((project, index) => {
    project.projectGroupPosition = index + 1;
  });
};

export const canStretchScene = () => (dispatch, getState) => {
  const { project, multiWallProjects } = getState().finalCheck;
  if (multiWallProjects.length == 1) {
    return !project.scenePlacings[0].tiled && !project.backgroundColor;
  }
  return getState().fabricCanvas.projectGroupSharedScene;
};

export const addNewProject = () => (dispatch, getState) => {
  if (dispatch(multiWallSupport())) {
    const {
      multiWallProjects,
      activeMultiWallProjectIndex,
      project
    } = getState().finalCheck;

    if (project.direction == WALL_DIRECTION.LEFT) {
      multiWallProjects.splice(0, 0, project);
      dispatch({
        type: actionTypes.SET_ACTIVE_MULTIWALL_PROJECT_INDEX,
        payload: {
          activeMultiWallProjectIndex: activeMultiWallProjectIndex + 1
        }
      });
    } else {
      multiWallProjects.push(project);
    }
    dispatch(rearrangeProjectGroupPosition());

    dispatch({
      type: actionTypes.SET_MULTIWALL_PROJECTS,
      payload: {
        multiWallProjects
      }
    });
    if (multiWallProjects.length == 2) {
      dispatch(updateCanvasForChangeInSize());
    }
    if (multiWallProjects.length > 1) {
      dispatch(resetActiveProject());
      if (dispatch(isSharedScene())) {
        dispatch(stretchScene());
      }
    }
  }
};

export const hasLeftMultiWallProjects = () => (dispatch, getState) => {
  const { activeMultiWallProjectIndex } = getState().finalCheck;
  return activeMultiWallProjectIndex > 0;
};

export const hasRightMultiWallProjects = () => (dispatch, getState) => {
  const {
    activeMultiWallProjectIndex,
    multiWallProjects
  } = getState().finalCheck;
  return activeMultiWallProjectIndex < multiWallProjects.length - 1;
};

export const navigateToRightWall = () => (dispatch, getState) => {
  const { activeMultiWallProjectIndex } = getState().finalCheck;
  const rightIndex = activeMultiWallProjectIndex + 1;
  dispatch(navigateToProjectWithIndex(rightIndex));
};

export const navigateToLefttWall = () => (dispatch, getState) => {
  const { activeMultiWallProjectIndex } = getState().finalCheck;
  const leftIndex = activeMultiWallProjectIndex - 1;
  dispatch(navigateToProjectWithIndex(leftIndex));
};

export const navigateToProjectWithIndex = index => (dispatch, getState) => {
  dispatch({
    type: actionTypes.SET_SAVE_VIA_WALL_NAVIGATION,
    payload: { isSaveViaWallNavigation: true }
  });
  dispatch(saveOnlyIfDirtyAndCall()).then(() => {
    dispatch({
      type: actionTypes.SET_SAVE_VIA_WALL_NAVIGATION,
      payload: { isSaveViaWallNavigation: false }
    });
    const { multiWallProjects } = getState().finalCheck;

    if (multiWallProjects[index]) {
      dispatch(clearCanvas());
      dispatch({
        type: actionTypes.SET_ACTIVE_MULTIWALL_PROJECT_INDEX,
        payload: { activeMultiWallProjectIndex: index }
      });

      const navigatedWallProject = multiWallProjects[index];
      navigatedWallProject.sharedScene = getState().fabricCanvas.projectGroupSharedScene;
      dispatch({
        type: actionTypes.SET_PROJECT_STRUCTURE,
        payload: { project: navigatedWallProject }
      });
      dispatch({
        type: actionTypes.SET_PROJECT_SIZE,
        payload: {
          width: navigatedWallProject.width,
          height: navigatedWallProject.height
        }
      });
      dispatch(loadCanvasFromProject());
    }
  });
};

export const leftWallSize = () => (dispatch, getState) => {
  const { dimensions } = getState().fabricCanvas;
  if (dispatch(hasLeftMultiWallProjects())) {
    const {
      activeMultiWallProjectIndex,
      multiWallProjects
    } = getState().finalCheck;
    const leftIndex = activeMultiWallProjectIndex - 1;
    const leftProject = multiWallProjects[leftIndex];
    const ratio = leftProject.height / leftProject.width;
    return {
      width: dimensions.canvasWallScaleHeight / ratio,
      height: dimensions.canvasWallScaleHeight
    };
  }
  return {
    width: dimensions.canvasWallScaleWidth,
    height: dimensions.canvasWallScaleHeight
  };
};

export const rightWallSize = () => (dispatch, getState) => {
  const { dimensions } = getState().fabricCanvas;

  if (dispatch(hasRightMultiWallProjects())) {
    const {
      activeMultiWallProjectIndex,
      multiWallProjects
    } = getState().finalCheck;
    const rightIndex = activeMultiWallProjectIndex + 1;
    const rightProject = multiWallProjects[rightIndex];
    const ratio = rightProject.height / rightProject.width;
    return {
      width: dimensions.canvasWallScaleHeight / ratio,
      height: dimensions.canvasWallScaleHeight
    };
  }
  return {
    width: dimensions.canvasWallScaleWidth,
    height: dimensions.canvasWallScaleHeight
  };
};

export const getContainerWidth = () => dispatch => {
  const leftProjectsWidth = dispatch(getLeftProjectsWidth());
  const rightProjectsWidth = dispatch(getRightWithCurrentProjectsWidth());
  return leftProjectsWidth + rightProjectsWidth;
};

export const getLeftProjectsWidth = () => (dispatch, getState) => {
  const {
    multiWallProjects,
    activeMultiWallProjectIndex
  } = getState().finalCheck;
  const { dimensions, projectGroupSharedScene } = getState().fabricCanvas;
  const { orgWindowWidth, orgWindowHeight } = dimensions;
  let containerWidth = 0;
  multiWallProjects.forEach((inProject, index) => {
    if (activeMultiWallProjectIndex > index && projectGroupSharedScene) {
      const projectWidth = inProject.width;
      const projectHeight = inProject.height;
      const { canvasSize } = dispatch(
        calculateRoomAndWallViewSize(orgWindowWidth, orgWindowHeight, {
          width: projectWidth,
          height: projectHeight
        })
      );
      containerWidth += canvasSize.width;
    }
  });
  return containerWidth;
};

export const getRightWithCurrentProjectsWidth = () => (dispatch, getState) => {
  const {
    multiWallProjects,
    activeMultiWallProjectIndex
  } = getState().finalCheck;
  const { dimensions, projectGroupSharedScene } = getState().fabricCanvas;
  const { orgWindowWidth, orgWindowHeight } = dimensions;
  const { projectWidth, projectHeight } = getState().home;
  const { canvasSize } = dispatch(
    calculateRoomAndWallViewSize(orgWindowWidth, orgWindowHeight, {
      width: projectWidth,
      height: projectHeight
    })
  );

  let containerWidth = canvasSize.width;
  multiWallProjects.forEach((inProject, index) => {
    if (activeMultiWallProjectIndex < index && projectGroupSharedScene) {
      const sizes = dispatch(
        calculateRoomAndWallViewSize(orgWindowWidth, orgWindowHeight, {
          width: inProject.width,
          height: inProject.height
        })
      );
      containerWidth += sizes.canvasSize.width;
    }
  });
  return containerWidth;
};

export const getMultiProjectsWidth = () => dispatch => {
  const leftProjectsWidth = dispatch(getModelLeftProjectsWidth());
  const rightProjectsWidth = dispatch(getModelRightWithCurrentProjectsWidth());
  return leftProjectsWidth + rightProjectsWidth;
};

export const getModelLeftProjectsWidth = () => (dispatch, getState) => {
  const {
    multiWallProjects,
    activeMultiWallProjectIndex
  } = getState().finalCheck;
  const { projectGroupSharedScene } = getState().fabricCanvas;

  let containerWidth = 0;
  multiWallProjects.forEach((inProject, index) => {
    if (activeMultiWallProjectIndex > index && projectGroupSharedScene) {
      containerWidth += inProject.width;
    }
  });
  return containerWidth;
};

export const getModelRightWithCurrentProjectsWidth = () => (
  dispatch,
  getState
) => {
  const {
    multiWallProjects,
    activeMultiWallProjectIndex
  } = getState().finalCheck;
  const { projectGroupSharedScene } = getState().fabricCanvas;
  const { projectWidth } = getState().home;

  let containerWidth = projectWidth;
  multiWallProjects.forEach((inProject, index) => {
    if (activeMultiWallProjectIndex < index && projectGroupSharedScene) {
      containerWidth += inProject.width;
    }
  });
  return containerWidth;
};

export const generatePreviewsOfSideWalls = () => (dispatch, getState) => {
  const {
    multiWallProjects,
    activeMultiWallProjectIndex
  } = getState().finalCheck;

  if (activeMultiWallProjectIndex > 0) {
    const leftProject = multiWallProjects[activeMultiWallProjectIndex - 1];
    const renderJson = dispatch(renderJSONForWalls(leftProject, false));
    dispatch({
      type: actionTypes.SET_LEFT_PREVIEW_IN_PROGESS,
      payload: { inProgress: true }
    });
    renderProject(renderJson, dataURLs => {
      if (getState().finalCheck.leftPreviewInProgress) {
        dispatch({
          type: actionTypes.SET_LEFT_WALL_PREVIEWS,
          payload: { leftWallPreviews: dataURLs }
        });
      }
    });
  } else {
    dispatch({
      type: actionTypes.SET_LEFT_PREVIEW_IN_PROGESS,
      payload: { inProgress: false }
    });
    dispatch({
      type: actionTypes.SET_LEFT_WALL_PREVIEWS,
      payload: { leftWallPreviews: [] }
    });
  }
  if (activeMultiWallProjectIndex < multiWallProjects.length - 1) {
    const rightProject = multiWallProjects[activeMultiWallProjectIndex + 1];
    const renderJson = dispatch(renderJSONForWalls(rightProject, false));
    dispatch({
      type: actionTypes.SET_RIGHT_PREVIEW_IN_PROGESS,
      payload: { inProgress: true }
    });
    renderProject(renderJson, dataURLs => {
      if (getState().finalCheck.rightPreviewInProgress) {
        dispatch({
          type: actionTypes.SET_RIGHT_WALL_PREVIEWS,
          payload: { rightWallPreviews: dataURLs }
        });
      }
    });
  } else {
    dispatch({
      type: actionTypes.SET_RIGHT_PREVIEW_IN_PROGESS,
      payload: { inProgress: false }
    });
    dispatch({
      type: actionTypes.SET_RIGHT_WALL_PREVIEWS,
      payload: { rightWallPreviews: [] }
    });
  }
};

const redrawCurrentProjectScene = () => (dispatch, getState) => {
  const { wallCanvas } = getState().fabricCanvas;
  let sceneElement = null;
  wallCanvas.getObjects().forEach(obj => {
    if (isImageBasedBackground(obj)) {
      sceneElement = obj;
    }
  });
  if (sceneElement) {
    const backupPlacing = sceneElement.placing;
    dispatch(setScenePlacingOffsetAndSize(backupPlacing));
    dispatch(destroyElement(sceneElement));
    dispatch(continueAddToCanvas(backupPlacing, null, () => {}));
  }
};

export const stretchScene = () => (dispatch, getState) => {
  const { project } = getState().finalCheck;
  dispatch(setSharedSceneTo(project, true));
  dispatch(redrawCurrentProjectScene());
};

export const unstretchScene = () => (dispatch, getState) => {
  const { project } = getState().finalCheck;
  dispatch(setSharedSceneTo(project, false));
  dispatch(unstretchSideProjects());
  dispatch(redrawCurrentProjectScene());
};

export const setSharedSceneTo = (aProject, value) => dispatch => {
  aProject.sharedScene = value;
  dispatch({
    type: actionTypes.SET_PROJECT_GROUP_SHARED_SCENE,
    payload: { projectGroupSharedScene: value }
  });
};

export const unstretchSideProjects = () => (dispatch, getState) => {
  // On unstrecthing the scene , other projects will get the last saved scene. But if it was stretched
  // because of stretch scene then we should reset it to original size. If it was because of Scale then
  // we shouldnt reset it to original size. That is handled using the check aProject.sharedScene
  getState().finalCheck.multiWallProjects.forEach(aProject => {
    if (aProject.sharedScene) {
      const scenePlacing = aProject.scenePlacings[0];
      dispatch(setScenePlacingOffsetAndSize(scenePlacing));
    }
  });
};

export const isSharedScene = () => (dispatch, getState) =>
  getState().fabricCanvas.projectGroupSharedScene;

export const getSharedScenePlacingSizeAndOffset = inProject => (
  dispatch,
  getState
) => {
  const { multiWallProjects } = getState().finalCheck;
  const { sharedSceneData } = getState().fabricCanvas;
  const { sharedScenePlacing, sharedSceneProjectIndex } = sharedSceneData;
  const projectIndex = multiWallProjects.findIndex(
    aProject => aProject.id == inProject.id
  );
  const placingWidth = sharedScenePlacing.width;
  const placingHeight = sharedScenePlacing.height;
  const placingYOffset = sharedScenePlacing.yOffset;
  let placingXOffset = sharedScenePlacing.xOffset;

  if (projectIndex != -1) {
    if (projectIndex < sharedSceneProjectIndex) {
      let leftIndex = sharedSceneProjectIndex - 1;
      while (leftIndex >= projectIndex) {
        placingXOffset += multiWallProjects[leftIndex].width;
        leftIndex--;
      }
    } else if (projectIndex > sharedSceneProjectIndex) {
      let rightIndex = sharedSceneProjectIndex + 1;
      while (rightIndex <= projectIndex) {
        placingXOffset -= multiWallProjects[rightIndex].width;
        rightIndex++;
      }
    }
  }
  return {
    xOffset: placingXOffset,
    yOffset: placingYOffset,
    width: placingWidth,
    height: placingHeight,
    flipX: sharedScenePlacing.flipX,
    imagePath: dispatch(getElementImagePath(sharedScenePlacing))
  };
};

export const generateWallVisualizeIds = () => (dispatch, getState) => {
  const { multiWallProjects } = getState().finalCheck;
  const wallVisualizeIds = [];
  if (
    dispatch(hasLeftMultiWallProjects()) ||
    multiWallProjects.length == MULTI_WALLS_LIMIT
  ) {
    wallVisualizeIds.push('wall 0');
  } else {
    wallVisualizeIds.push(null);
  }

  if (
    dispatch(hasLeftMultiWallProjects()) ||
    multiWallProjects.length == MULTI_WALLS_LIMIT
  ) {
    wallVisualizeIds.push('wall 1');
  } else {
    wallVisualizeIds.push('wall 0');
  }

  if (multiWallProjects.length == MULTI_WALLS_LIMIT) {
    wallVisualizeIds.push('wall 2');
  } else if (dispatch(hasRightMultiWallProjects())) {
    wallVisualizeIds.push('wall 1');
  } else {
    wallVisualizeIds.push(null);
  }
  return wallVisualizeIds;
};

export const getActiveWallVisualizeDirection = wallVisualizeIds => (
  dispatch,
  getState
) => {
  const { activeMultiWallProjectIndex } = getState().finalCheck;
  let matchedIndex = 1;
  let direction;

  wallVisualizeIds.forEach((id, index) => {
    const createdId = `wall ${activeMultiWallProjectIndex}`;
    if (createdId == id) {
      matchedIndex = index;
    }
  });
  switch (matchedIndex) {
    case 0:
      direction = WALL_DIRECTION.LEFT;
      break;
    case 2:
      direction = WALL_DIRECTION.RIGHT;
      break;
    case 1:
    default:
      direction = WALL_DIRECTION.CENTER;
      break;
  }
  return direction;
};

export const getWallIndex = (oldDirection, newDirection) => (
  dispatch,
  getState
) => {
  const { activeMultiWallProjectIndex } = getState().finalCheck;

  if (oldDirection == WALL_DIRECTION.LEFT) {
    if (newDirection == WALL_DIRECTION.CENTER) {
      return activeMultiWallProjectIndex + 1;
    }
    if (newDirection == WALL_DIRECTION.RIGHT) {
      return activeMultiWallProjectIndex + 2;
    }
  }
  if (oldDirection == WALL_DIRECTION.CENTER) {
    if (newDirection == WALL_DIRECTION.LEFT) {
      return activeMultiWallProjectIndex - 1;
    }
    if (newDirection == WALL_DIRECTION.RIGHT) {
      return activeMultiWallProjectIndex + 1;
    }
  }
  if (oldDirection == WALL_DIRECTION.RIGHT) {
    if (newDirection == WALL_DIRECTION.LEFT) {
      return activeMultiWallProjectIndex - 2;
    }
    if (newDirection == WALL_DIRECTION.CENTER) {
      return activeMultiWallProjectIndex - 1;
    }
  }
  return activeMultiWallProjectIndex;
};

export const hasSingleWallDesign = () => (dispatch, getState) => {
  const { multiWallProjects } = getState().finalCheck;
  return (
    dispatch(checkIfCanvasApp()) ||
    (dispatch(multiWallSupport()) && multiWallProjects.length < 2)
  );
};

export const hasMultiWallDesign = () => (dispatch, getState) => {
  const { multiWallProjects } = getState().finalCheck;
  return dispatch(multiWallSupport()) && multiWallProjects.length >= 2;
};

export const setActiveProjectTempororily = tempProject => (
  dispatch,
  getState
) => {
  const { project } = getState().finalCheck;
  dispatch({
    type: actionTypes.BACKUP_ACTIVE_PROJECT,
    payload: { backupProject: project }
  });

  dispatch({
    type: actionTypes.SET_PROJECT_STRUCTURE,
    payload: { project: tempProject }
  });
};

export const resetActiveProject = () => (dispatch, getState) => {
  if (dispatch(hasMultiWallDesign())) {
    const { backupProject } = getState().finalCheck;
    if (backupProject) {
      dispatch({
        type: actionTypes.SET_PROJECT_STRUCTURE,
        payload: { project: backupProject }
      });
    }
  }
};

export const shareProjectIsClicked = index => (dispatch, getState) => {
  const { multiWallProjects } = getState().finalCheck;

  if (dispatch(hasMultiWallDesign())) {
    const tempActiveProject = multiWallProjects[index];
    dispatch(setActiveProjectTempororily(tempActiveProject));
  }
};
